import { render, staticRenderFns } from "./OverViewComponent.vue?vue&type=template&id=1e717c2e&"
import script from "./OverViewComponent.vue?vue&type=script&lang=js&"
export * from "./OverViewComponent.vue?vue&type=script&lang=js&"
import style0 from "./OverViewComponent.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
